module.exports = __webpack_public_path__ + "img/wedcr7.2f893033.jpg";